export const config = {
  brand: {
    name: "Pro360",
    product: "Invitaciones Digitales Plus",
    productShort: "Invitaciones Plus",
    domain: "pro360.com.py",
  },
  whatsapp: {
    number: "595993258783",
    defaultMessage:
      "Hola Pro360, quiero consultar por Invitaciones Digitales Plus para mi evento.",
  },
  links: {
    privacy: "/politica-de-privacidad/",
    terms: "/condiciones-de-servicio/",
  },
};

export const whatsappUrl = (message) =>
  `https://wa.me/${config.whatsapp.number}?text=${encodeURIComponent(
    message || config.whatsapp.defaultMessage
  )}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
  else window.location.assign(`/#${id}`);
};
